'use strict';

var jsxRuntime = require('@emotion/react/jsx-runtime');
var react = require('@emotion/react');
var Skeleton_web = require('../Skeleton/Skeleton.web.cjs');
var Typography_web_styles = require('./Typography.web.styles.cjs');

/**
 * Typography wrapper component used to display text
 *
 * @scope Core
 */ const Typography = ({ type = "body", styleOverride, isMarginless = false, isSubdued = false, isLoading = false, children, ref: unusedRef, customCss, ...rest })=>{
    const theme = react.useTheme();
    const styleBuilder = ()=>{
        return [
            Typography_web_styles.typographySizes[type](theme),
            isSubdued && Typography_web_styles.isSubdued,
            Typography_web_styles.fullwidth,
            !isMarginless && Typography_web_styles.margin,
            styleOverride && Typography_web_styles.typographySizes[styleOverride](theme),
            customCss
        ];
    };
    const renderType = ()=>{
        switch(type){
            case "h1":
                return /*#__PURE__*/ jsxRuntime.jsx("h1", {
                    css: styleBuilder(),
                    ...rest,
                    children: children
                });
            case "h2":
                return /*#__PURE__*/ jsxRuntime.jsx("h2", {
                    css: styleBuilder(),
                    ...rest,
                    children: children
                });
            case "h3":
                return /*#__PURE__*/ jsxRuntime.jsx("h3", {
                    css: styleBuilder(),
                    ...rest,
                    children: children
                });
            case "h4":
                return /*#__PURE__*/ jsxRuntime.jsx("h4", {
                    css: styleBuilder(),
                    ...rest,
                    children: children
                });
            case "h5":
                return /*#__PURE__*/ jsxRuntime.jsx("h5", {
                    css: styleBuilder(),
                    ...rest,
                    children: children
                });
            default:
                return /*#__PURE__*/ jsxRuntime.jsx("p", {
                    css: styleBuilder(),
                    ...rest,
                    children: children
                });
        }
    };
    const getElement = ()=>{
        if (isLoading) {
            return /*#__PURE__*/ jsxRuntime.jsx(Skeleton_web.Skeleton, {
                type: "typography",
                typographyType: type,
                isFullWidth: true
            });
        }
        return renderType();
    };
    return getElement();
};
Typography.displayName = "Typography";

exports.Typography = Typography;
//# sourceMappingURL=Typography.web.cjs.map
